import React from "react";
import localeText from "../../../../../../locale";

const SettingsSidebar = ({ items, activeId, onSelect }) => (
  <div
    className="border-round-lg p-2 mb-3"
    style={{
      backgroundColor: "var(--theme-background, #fff)",
      border: "1px solid var(--theme-border, #EBEBEB)",
      minWidth: "15rem",
    }}
  >
    <div
      className="text-xs font-semibold uppercase mb-2 p-1"
      style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
    >
      {localeText("settingsMenuSelection") || "Menu de seleção"}
    </div>
    <ul className="list-none p-0 m-0 flex flex-column gap-1">
      {items.map((item) => (
        <li key={item.id}>
          <button
            type="button"
            className="w-full text-left border-none cursor-pointer p-2 border-round-md flex align-items-center gap-2 text-sm"
            style={{
              backgroundColor:
                activeId === item.id
                  ? "color-mix(in srgb, var(--theme-text, #171717) 6%, var(--theme-background, #FFFFFF))"
                  : "transparent",
            }}
            onClick={() => onSelect(item.id)}
          >
            <i
              className={item.icon}
              style={{
                color:
                  activeId === item.id
                    ? "var(--theme-primary, #1DAF61)"
                    : "var(--theme-text-muted, #5C5C5C)",
              }}
            />
            <span
              style={{
                color:
                  activeId === item.id
                    ? "var(--theme-text, #171717)"
                    : "var(--theme-text-muted, #5C5C5C)",
              }}
            >
              {item.label}
            </span>
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default SettingsSidebar;
